"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TreasureData = _interopRequireDefault(require("../TreasureData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var TreasureDataProvider = function TreasureDataProvider(_a) {
  var children = _a.children,
      settings = _a.settings,
      treasureData = _a.treasureData;

  var _b, _c, _d;

  (0, _react.useEffect)(function () {
    var _a, _b, _c;

    if (((_a = settings.FEATURE) === null || _a === void 0 ? void 0 : _a.TREASURE_DATA) && treasureData) {
      _TreasureData["default"].initialize(treasureData.HOST, treasureData.WRITEKEY, treasureData.DATABASE, (_c = (_b = settings.CONFIG) === null || _b === void 0 ? void 0 : _b.TREASURE_DATA) === null || _c === void 0 ? void 0 : _c.COOKIE_SYNC_ID);
    }
  }, [treasureData, (_b = settings.FEATURE) === null || _b === void 0 ? void 0 : _b.TREASURE_DATA, (_d = (_c = settings.CONFIG) === null || _c === void 0 ? void 0 : _c.TREASURE_DATA) === null || _d === void 0 ? void 0 : _d.COOKIE_SYNC_ID]);
  return _react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = TreasureDataProvider;
exports["default"] = _default;